module.exports = __webpack_public_path__ + "images/imageemail.bb21f034.png";